import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/m-rig-matrixradio@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  orderById: 60,
  isRequired: '1',
  elementType: 'RadioBoxGroup',
  elementDesc: '矩阵单选',
  type: 'radioboxgroup',
  // 是否可配置
  config: true,
  // 控件左侧label内容
  title: '矩阵单选',
  placeholder: '',
  itemName: 'optionList',
  descList: [{
    orderById: '1',
    optionName: '子问题1',
    type: 'normal',
    value: '',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '子问题2',
    type: 'normal',
    value: '',
    imgUrl: '',
    imgName: ''
  }],
  optionList: [{
    orderById: '1',
    optionName: '选项1',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '选项2',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }],
  vertical: true,
  value: '',
  ruleError: '该字段不能为空',
  // 选项随机排列   0顺序排列1随机排列2循环显示
  randOrder: '0',
  saveUrl: '/design/qu-radio-group/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      descList: util.genList(this.descList),
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.descList = util.genRetList.call(this, data.descList, 'desc', {value: '', otherAnswer: ''})
    this.optionList = util.genRetList.call(this, data.optionList, 'option')
  },
  getAnswer () {
    const answer = []
    this.descList.forEach(item => {
      answer.push({
        belongId: this.belongId,
        quId: this.id,
        belongAnswerId: this.belongAnswerId,
        quRowId: item.id,
        quColId: item.value
      })
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/RadioBoxGroup/config.js